/*** Pre Declare Filter Arrays ***/
const cut_array = {"Ideal": "Ideal","Excellent": "Excellent","Very Good": "Very Good","Good": "Good","Fair": "Fair"};

const polish_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good","Fair": "Fair","Poor": "Poor"};

const symmetry_array = {"Excellent": "Excellent","Very Good": "Very Good","Good": "Good","Fair": "Fair","Poor": "Poor"};

const fluorescence_array = {"None": "None", "Faint": "Faint", "Medium": "Medium","Strong": "Strong","Very Strong": "Very Strong"};

const clarity_array = {"FL": "FL","IF": "IF","VVS1": "VVS1","VVS2": "VVS2","VS1": "VS1","VS2": "VS2","SI1": "SI1","SI2": "SI2"};

const color_array = {"D": "D","E": "E","F": "F","G": "G","H": "H","I": "I","J": "J"};

const intensity_array = {"Faint":"Faint","Very Light":"Very Light","Light":"Light","Fancy Light":"Fancy Light","Fancy":"Fancy","Fancy Dark":"Fancy Dark","Intense":"Intense","Vivid":"Vivid","Deep":"Deep"};
/*** End ***/

//Initialze sorting array
var mySelection = [];

jQuery(document).ready(function(){
  setCutFilterVisibility();  
});

/**** Filter Tabs Functionality Start ****/  
// $(document).on("click", ".tps-tab", function() {
//     jQuery(".tps-tab").removeClass("active");
//     jQuery(this).addClass("active");
    
//     var filter_category = jQuery(this).attr("data-category");
//     jQuery('.tps-filter-details').removeClass("active");                       
//     jQuery('.tps-filter-'+filter_category).addClass("active"); 
//     jQuery('.tps-filter-details').css("display","none");   
//     jQuery('.tps-filter-'+filter_category).css("display","flex");    
//  });
/*** End ***/

/**** Advanced Filter Functionality Start ****/  
$(document).on("click", ".tps-advanced-filter-btn", function() {
    var filter_category = jQuery(this).attr("data-category");
    
    if(jQuery(this).hasClass("active")){
      jQuery(this).removeClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleAdvancedFilters+' <span class="tps-arrow-down"></span>'); 
      jQuery('.tps-filter-'+filter_category).slideUp('slow');    
    }else{
      jQuery(this).addClass("active");
      jQuery('.tps-advanced-filter-btn').html(translations.titleHideFilters+' <span class="tps-arrow-up"></span>');      
      jQuery('.tps-filter-'+filter_category).slideDown('slow');    
    }      
});
/*** End ***/

/**** Tooltip Information Open/Close Start ****/ 
function infoPopup(diamondField,action){  
  if(action == 'open'){
    $(".tps-diamond-field-"+diamondField).addClass('tps-popup-info-show');    
  }else{
    $(".tps-diamond-field-"+diamondField).removeClass('tps-popup-info-show');    
  }  
}
/**** Tooltip Information Open/Close End ****/ 

/*** Diamond Filter Tooltip Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','.tps-popup-info-show',function(e){
  var container = $(".tps-diamond-field-popup-section");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){      
    jQuery(".tps-diamond-field-popup-wrapper").removeClass("tps-popup-info-show");
  }
});
/*** Diamond Filter Tooltip Info Popoup Close Outer Click End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setCheckboxtypeFilter(ele,parentClass,valueid,filter){  
   var filter_value = jQuery(ele).find("input").attr('data-value');
   emptyResultDiv();
   if(jQuery(ele).hasClass('selected')){
      jQuery(ele).removeClass('selected');
   }else{
      jQuery(ele).addClass('selected');
   }
    
   var check_variable='';
  
    jQuery("."+parentClass+" input:checkbox" ).each(function(){
      if(jQuery(this).is(':checked')){
        if(check_variable==""){
          check_variable = jQuery(this).attr('value'); 
        }else{
          check_variable = check_variable+","+jQuery(this).attr('value');
        }            
      }
    });
    if(check_variable==''){
      $('#'+valueid).val('');
    }else{      
      $('#'+valueid).val(check_variable);
    }    
    
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSelectedFilter(filterTitle,filterFunction,hasClass,filter_value);
    //end
  
    // cut filter visibility according to shape selection 
    if(valueid == 'dia_shape'){
      if(jQuery('#dia_shape').val() == ''){
        if(JSON.parse(localStorage.getItem("ring-selected-setting"))) {
          var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));
          var can_be_match_with = setting_info[0].setting_can_be_match_with;
          $('#'+valueid).val(can_be_match_with);
        }
      }
      setCutFilterVisibility(check_variable);
    }

    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    graphqlDataCall();
    updateSessionFilters(session_variable+'-filters',filter, check_variable);
  
}
/*** End ***/

/*** Set Cut Filter Visibilty Start ***/
function setCutFilterVisibility(shapes = '') { 
  if(shapes == ''){
    var selectedShapes = "";
    jQuery(".tps-shape-filter-wrapper input:checkbox" ).each(function(){
      if(jQuery(this).is(':checked')){
        if(selectedShapes == ""){
          selectedShapes = jQuery(this).attr('value'); 
        }else{
          selectedShapes = selectedShapes+","+jQuery(this).attr('value');
        }            
      }
    });
    shapes = selectedShapes;
  }
  var shapesArr = shapes.split(",");
  
  if(shapes.indexOf("Round") >= 0 && shapesArr.length == 1){
    jQuery('.tps-filter-cut').show();
  }else if(shapes == ''){
    jQuery('.tps-filter-cut').show();
  }else{
    jQuery('.tps-filter-cut').hide();
    $('#cut_min_value').val(0);
    $('#cut_max_value').val(default_max_cut);
    var filterLabel = translations.titleCut;
    cut_slider_render(0, default_max_cut, true, filterLabel);
  }
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Fancy COlor Filter From Applied Filter Start ***/
function removeColorFilter(color){ 
  jQuery('.tps-filter-fancy-color-list input[data-value="'+color+'"]').click();
}
/*** Remove Fancy COlor Filter From Applied Filter End ***/

/*** Remove Report Filter From Applied Filter Start ***/
function removeLabFilter(lab){  
  jQuery('.tps-filter-report-list input[data-value="'+lab+'"]').click();
}
/*** Remove Report Filter From Applied Filter End ***/

/*** Remove Media Filter From Applied Filter Start ***/
function removeMediaFilter(media){  
  jQuery('.tps-filter-media-list input[data-value="'+media+'"]').click();
}
/*** Remove Media Filter From Applied Filter End ***/

/*** Remove search by certificate number Filter From Applied Filter Start ***/
function removeSearchByCertificateFilter(){  
  emptyResultDiv();
  resetFilters(true);
}
/*** Remove search by certificate number Filter Filter End ***/

/*** Color Range Slider Filter Start ***/
function color_slider_render(start,end,option,filterTitle){ 
  //dynamic style left % 
  var colorSlot = 100/default_max_color;
  for (n = 1; n < default_max_color; n++) {
    var claritySoltLeft = n*colorSlot;
    jQuery(".tps-color-range-"+n).css("left", claritySoltLeft+"%");
  }
  
  var filterLable = filterTitle+':';
    
  //session color filter selected
  var isSelected = false;
  if(start != 0 || end != default_max_color){
     isSelected = true;
  }
  
  var selected_values = getFilterValues(min_color,max_color,'color');  
  if(selected_values[0] == selected_values[1]){
    var filterValues = filterLable+' '+selected_values[1];
  }else{
    var filterValues = filterLable+' '+selected_values[0]+' - '+selected_values[1];
  }    
  setSelectedFilter(filterValues,"color_slider_render('0', '"+default_max_color+"','false')",isSelected,'color');
  //end
  
    jQuery("#tps_color_range_slider").slider({ 
      range: true,
      values: [start, end],
       min: 0,
       max: default_max_color,
       step: 1, 
       slide: function( event, ui ) {  
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#color_min_value").val(ui.values[0]);
          jQuery("#color_max_value").val(ui.values[1]);
           
      },
      change: function( event, ui ) { 
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#color_min_value").val(ui.values[0]);
         jQuery("#color_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_color){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'color');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleColor+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleColor+': '+selected_values[0]+' - '+selected_values[1];    
         }  
         setSelectedFilter(filterValues,"color_slider_render('0', '"+default_max_color+"','false')",isSelected,'color');
        
         updateSessionFilters(session_variable+'-filters',filterTitle, ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
            jQuery('#pagination').val('');
            graphqlDataCall();
         }
        return false;
      }
   });
}
/*** End ***/

/*** Clarity Range Slider Filter Start ***/
function clarity_slider_render(start,end,option,filterTitle){
  //dynamic style left % 
  var claritySlot = 100/default_max_clarity;
  for (n = 1; n < default_max_clarity; n++) {
    var claritySoltLeft = n*claritySlot;
    jQuery(".tps-clarity-range-"+n).css("left", claritySoltLeft+"%");
  }
  
  var filterLabel = filterTitle+':'; 
  
  //session clarity filter selected
  var isSelected = false;
  if(start != 0 || end != default_max_clarity){
     isSelected = true;
  }

  var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');
  if(selected_values[0] == selected_values[1]){
    var filterValues = filterLabel+' '+selected_values[1];
  }else{
      var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
  }
  setSelectedFilter(filterValues,"clarity_slider_render('0', '"+default_max_clarity+"','false')",isSelected,'clarity');
  //end

    jQuery("#tps_clarity_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_clarity,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#clarity_min_value").val(ui.values[0]);
          jQuery("#clarity_max_value").val(ui.values[1]);           
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#clarity_min_value").val(ui.values[0]);
         jQuery("#clarity_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_clarity){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleClarity+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleClarity+': '+selected_values[0]+' - '+selected_values[1];    
         }          
          
         setSelectedFilter(filterValues,"clarity_slider_render('0', '"+default_max_clarity+"','false')",isSelected,'clarity');
         updateSessionFilters(session_variable+'-filters',filterTitle,ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
            jQuery('#pagination').val('');
            graphqlDataCall();
         }
         return false;
      }
   });
}
/*** End ***/

/*** Cut Range Slider Filter Start ***/
function cut_slider_render(start,end,option,filterTitle){  
  //dynamic style left % 
  var cutSlot = 100/default_max_cut;
  for (n = 1; n < default_max_cut; n++) {
    var cutSoltLeft = n*cutSlot;
    jQuery(".tps-cut-range-"+n).css("left", cutSoltLeft+"%");
  }
  
  var filterLabel = filterTitle+':';
 
  //session cut filter selected
  var isSelected = false;
  if(start != 0 || end != default_max_cut){
     isSelected = true;
  }
  
  var selected_values = getFilterValues(min_cut,max_cut,'cut');  
  if(selected_values[0] == selected_values[1]){
    var filterValues = filterLabel+' '+selected_values[1];
  }else{
    var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
  }        
  setSelectedFilter(filterValues,"cut_slider_render('0', '"+default_max_cut+"','false')",isSelected,'cut');
  //end
  
  jQuery("#tps_cut_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_cut,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#cut_min_value").val(ui.values[0]);
          jQuery("#cut_max_value").val(ui.values[1]);
           
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#cut_min_value").val(ui.values[0]);
         jQuery("#cut_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_cut){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'cut');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleCut+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleCut+': '+selected_values[0]+' - '+selected_values[1];    
         }   
         setSelectedFilter(filterValues,"cut_slider_render('0', '"+default_max_cut+"','false')",isSelected,'cut');
         updateSessionFilters(session_variable+'-filters',filterTitle, ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
    	      jQuery('#pagination').val('');
            graphqlDataCall();
         }
        return false;
      }
   });
}
/*** End ***/

/*** Fluorescence Range Slider Filter Start ***/
function fluorescence_slider_render(start,end,option,filterTitle){  
    //dynamic style left % 
    var flourSlot = 100/default_max_flour;
    for (n = 1; n < default_max_flour; n++) {
      var flourSoltLeft = n*flourSlot;
      jQuery(".tps-flour-range-"+n).css("left", flourSoltLeft+"%");
    }
  
    var filterLabel = filterTitle+':';
  
   //session fluorescence filter selected
    var isSelected = false;
    if(start != 0 || end != default_max_flour){
       isSelected = true;
    }
  
    var selected_values = getFilterValues(min_flour,max_flour,'fluorescence');
    if(selected_values[0] == selected_values[1]){
      var filterValues = filterLabel+' '+selected_values[1];
    }else{
      var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
    }
    setSelectedFilter(filterValues,"fluorescence_slider_render('0', '"+default_max_flour+"','false')",isSelected,'fluorescence');
    //end

    jQuery("#tps_flour_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_flour,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#fluorescence_min_value").val(ui.values[0]);
          jQuery("#fluorescence_max_value").val(ui.values[1]);
           
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#fluorescence_min_value").val(ui.values[0]);
         jQuery("#fluorescence_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_flour){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'fluorescence');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleFluorescence+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleFluorescence+': '+selected_values[0]+' - '+selected_values[1];    
         }                 
         setSelectedFilter(filterValues,"fluorescence_slider_render('0', '"+default_max_flour+"','false')",isSelected,'fluorescence');
         updateSessionFilters(session_variable+'-filters',filterTitle,ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
            jQuery('#pagination').val('');
            graphqlDataCall();
         }
        return false;
      }
   });
}
/*** End ***/

/*** Symmetry Range Slider Filter Start ***/
function symmetry_slider_render(start,end,option,filterTitle){
    //dynamic style left % 
    var symmSlot = 100/default_max_symm;
    for (n = 1; n < default_max_symm; n++) {
      var symmSoltLeft = n*symmSlot;
      jQuery(".tps-symme-range-"+n).css("left", symmSoltLeft+"%");
    }
  
    var filterLabel = filterTitle+':';
  
    //session Symmetry filter selected
    var isSelected = false;
    if(start != 0 || end != default_max_symm){
       isSelected = true;
    }
  
    var selected_values = getFilterValues(min_symm,max_symm,'symmetry');  
    if(selected_values[0] == selected_values[1]){
      var filterValues = filterLabel+' '+selected_values[1];
    }else{
      var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
    }  
    setSelectedFilter(filterValues,"symmetry_slider_render('0', '"+default_max_symm+"','false')",isSelected,'symmetry');
    //end
  
    jQuery("#tps_symme_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_symm,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#symmetry_min_value").val(ui.values[0]);
          jQuery("#symmetry_max_value").val(ui.values[1]);             
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#symmetry_min_value").val(ui.values[0]);
         jQuery("#symmetry_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_symm){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'symmetry');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titleSymmetry+': '+selected_values[1];    
         }else{
            var filterValues = translations.titleSymmetry+': '+selected_values[0]+' - '+selected_values[1];    
         }       
         setSelectedFilter(filterValues,"symmetry_slider_render('0', '"+default_max_symm+"','false')",isSelected,'symmetry');
         updateSessionFilters(session_variable+'-filters',filterTitle,ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
            jQuery('#page_no').val(1);
            jQuery('#pagination').val('');
            graphqlDataCall();
         }
        return false;
      }
   });
}
/*** End ***/

/*** Polish Range Slider Filter Start ***/
function polish_slider_render(start,end,option,filterTitle){
    //dynamic style left % 
    var polishSlot = 100/default_max_polish;
    for (n = 1; n < default_max_polish; n++) {
      var polishSoltLeft = n*polishSlot;
      jQuery(".tps-polish-range-"+n).css("left", polishSoltLeft+"%");
    }
  
    var filterLabel = filterTitle+':';
   
    //session Polish filter selected
    var isSelected = false;
    if(start != 0 || end != default_max_polish){
       isSelected = true;
    }
  
    var selected_values = getFilterValues(min_polish,max_polish,'polish');  
    if(selected_values[0] == selected_values[1]){
        var filterValues = filterLabel+' '+selected_values[1];
    }else{
        var filterValues = filterLabel+' '+selected_values[0]+' - '+selected_values[1];
    }  
    setSelectedFilter(filterValues,"polish_slider_render('0', '"+default_max_polish+"','false')",isSelected,'polish');
    //end
  
    jQuery("#tps_polish_range_slider").slider({ 
       range: true,
       values: [start, end],
       min: 0,
       max: default_max_polish,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery("#polish_min_value").val(ui.values[0]);
          jQuery("#polish_max_value").val(ui.values[1]);           
      },
      change: function( event, ui ) {  
         var resetFlag = checkResetFlag();
         emptyResultDiv();
        
         jQuery("#polish_min_value").val(ui.values[0]);
         jQuery("#polish_max_value").val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != default_max_polish){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'polish');
          
         if(selected_values[0] == selected_values[1]){
            var filterValues = translations.titlePolish+': '+selected_values[1];    
         }else{
            var filterValues = translations.titlePolish+': '+selected_values[0]+' - '+selected_values[1];    
         } 
         setSelectedFilter(filterValues,"polish_slider_render('0', '"+default_max_polish+"','false')",isSelected,'polish');
         updateSessionFilters(session_variable+'-filters',filterTitle,ui.values[0]+","+ui.values[1]);
         //end

         if(resetFlag != 'true'){
           jQuery('#page_no').val(1);
           jQuery('#pagination').val('');
           graphqlDataCall();
         }
         return false;
      }
   });
}
/*** End ***/

/*** Table Slider Filter Start ***/
function getTableCalibArray(table_min,table_max) {  
  var table = [];
  for(i = parseInt(table_min); i < parseInt(table_max); i = i + 0.10){
  	var dec = i.toFixed(2);
  	table.push(dec);
  }
  return table;
}

function table_slider_render(min_table, max_table, option, filterLabel) {
    var table = getTableCalibArray(default_table_min,default_table_max);
	var minTable = getClosestNum(min_table, table);
	var maxTable = getClosestNum(max_table, table);
	var table_min = get_index(minTable, table);	
	var table_max = get_index(maxTable, table);

    //session depth filter selected
     var isSelected = false;
     if(parseInt(min_table) != parseInt(default_table_min) || parseInt(max_table) != parseInt(default_table_max)){
       isSelected = true;
     }

     var filterValues = filterLabel+': '+min_table+' % - '+max_table+' %';
     setSelectedFilter(filterValues,"table_slider_render('"+parseInt(default_table_min)+"', '"+parseInt(default_table_max)+"','true')",isSelected,'table');
     //end
  
	jQuery("#tps_table_slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [table_min, table_max],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])] + '%');
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            var resetFlag = checkResetFlag();
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {		
                $("#table_from").val(table[parseInt(ui.values[0])] + '%');
                $('#table_left_hidden').val(table[parseInt(ui.values[0])]);
                $('#table_to').val(table[parseInt(ui.values[1])] + '%');
                $('#table_right_hidden').val(table[parseInt(ui.values[1])]);
             
                //applied filter start
                 var isSelected = false;
                 if(table[parseInt(ui.values[0])] != parseInt(default_table_min) || table[parseInt(ui.values[1])] != parseInt(default_table_max)){
                       isSelected = true;
                 }
                var filterValues = translations.titleTable.replace(' %', '')+': '+table[parseInt(ui.values[0])] + ' %'+' - '+table[parseInt(ui.values[1])] + ' %';
                setSelectedFilter(filterValues,"table_slider_render('"+default_table_min+"', '"+default_table_max+"','true')",isSelected,'table');
                updateSessionFilters(session_variable+'-filters',filterLabel,table[parseInt(ui.values[0])]+","+table[parseInt(ui.values[1])]);

                if(resetFlag != 'true'){
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');
                  graphqlDataCall();          
                }
			}
		}

	});

	var start_limit = parseFloat(min_table);
	var end_limit = parseFloat(max_table);

	$("#table_from").val(start_limit.toFixed(2) + '%');
	$("#table_to").val(end_limit.toFixed(2) + '%');

	$('#table_left_hidden').val(min_table);
	$('#table_right_hidden').val(max_table);
}

function replace_table_from(ele,min_table,filterLabel) {    
	if($('#table_from').val() == '') {
		var min_value = parseFloat($('#table_left_hidden').val());
		$('#table_from').val((min_value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat($('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var table_min_value = parseFloat($('#table_from').val());
	var table_max_value = parseFloat($('#table_to').val());
	
	if(isNaN(table_min_value) != false) {
		var value = parseFloat(default_table_min);
		alert(translations.titlePleaseEnterValueInNumber);
		$('#table_from').val(value + '%');
        return false;
	} else if (table_min_value > table_max_value) {
		alert(translations.titleIncorrectTableRange);
		var min_value = parseFloat($('#table_left_hidden').val());
		$('#table_from').val((min_value.toFixed(2)) + '%');
		return false;
	} else if (table_value < default_table_min) {
		alert(translations.titleIncorrectTableRange);
		$('#table_from').val(default_table_min + "%");
		table_slider_render(default_table_min, table_max_value, true);
		return false;
	}

	$('#table_left_hidden').val(table_min_value);
	$('#table_right_hidden').val(table_max_value);

	table_slider_render(table_min_value, table_max_value, true,filterLabel);
}

function replace_table_to(ele,max_table,filterLabel) {
	if (jQuery('#table_to').val() == '') {
		var max_value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}
    
	var table_min_value = parseFloat($('#table_from').val());
    var table_max_value = parseFloat(jQuery('#table_to').val());
	
	if (isNaN(table_max_value) != false) {
		var max_value = default_table_max;
		alert(translations.titlePleaseEnterValueInNumber);
		jQuery('#table_to').val(max_value + '%');
        return false;
	} else if (table_min_value > table_max_value) {
		alert(translations.titleIncorrectTableRange);
		var max_value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((max_value.toFixed(2)) + '%');
		return false;
	} else if (table_max_value > default_table_max) {
		$('#table_to').val(default_table_max + "%");
		table_slider_render(table_min_value, default_table_max, true);
		return false;
	}

	$('#table_right_hidden').val(table_max_value);
	$('#table_left_hidden').val(table_min_value);

	table_slider_render(table_min_value, table_max_value, true, filterLabel);
}
/*** End ***/

/*** Depth Slider Filter Start ***/
function getDepthCalibArray(depth_min,depth_max) {  
  var depth = [];
  for(i = parseInt(depth_min); i < parseInt(depth_max); i = i + 0.10){
  	var dec = i.toFixed(2);
  	depth.push(dec);
  }
  return depth;
}

function depth_slider_render(min_depth, max_depth, option, filterLabel) {
    var depth = getDepthCalibArray(default_depth_min,default_depth_max);
	var minDepth = getClosestNum(min_depth, depth);
	var maxDepth = getClosestNum(max_depth, depth);
	var depth_min = get_index(minDepth, depth);	
	var depth_max = get_index(maxDepth, depth);

    //session depth filter selected
     var isSelected = false;
     if(parseInt(min_depth) != parseInt(default_depth_min) || parseInt(max_depth) != parseInt(default_depth_max)){
       isSelected = true;
     }

     var filterValues = filterLabel+': '+min_depth+' % - '+max_depth+' %';
     setSelectedFilter(filterValues,"depth_slider_render('"+parseInt(default_depth_min)+"', '"+parseInt(default_depth_max)+"','true')",isSelected,'depth');
     //end
  
	jQuery("#tps_depth_slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [depth_min, depth_max],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            var resetFlag = checkResetFlag();
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {	
                $("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
                $('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
                $('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
                $('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
             
                //applied filter start
                 var isSelected = false;
                 if(depth[parseInt(ui.values[0])] != parseInt(default_depth_min) || depth[parseInt(ui.values[1])] != parseInt(default_depth_max)){
                       isSelected = true;
                 }
                var filterValues = translations.titleDepth.replace(' %', '')+': '+depth[parseInt(ui.values[0])] + ' %'+' - '+depth[parseInt(ui.values[1])] + ' %';
                setSelectedFilter(filterValues,"depth_slider_render('"+default_depth_min+"', '"+default_depth_max+"','true')",isSelected,'depth');
                updateSessionFilters(session_variable+'-filters',filterLabel,depth[parseInt(ui.values[0])]+","+depth[parseInt(ui.values[1])]);
              
                if(resetFlag != 'true'){
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');	
                  graphqlDataCall();   
                }
			}
		}

	});

	var start_limit = parseFloat(min_depth);
	var end_limit = parseFloat(max_depth);

	$("#depth_from").val(start_limit.toFixed(2) + '%');
	$("#depth_to").val(end_limit.toFixed(2) + '%');

	$('#depth_left_hidden').val(min_depth);
	$('#depth_right_hidden').val(max_depth);
}

function replace_depth_from(ele,depth_min,filterLabel) {    
	if($('#depth_from').val() == '') {
		var min_value = parseFloat($('#depth_left_hidden').val());
		$('#depth_from').val((min_value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat($('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var depth_min_value = parseFloat($('#depth_from').val());
	var depth_max_value = parseFloat($('#depth_to').val());
	
	if(isNaN(depth_min_value) != false) {
		var value = parseFloat(default_depth_min);
		alert(translations.titlePleaseEnterValueInNumber);
		$('#depth_from').val(value + '%');
        return false;
	} else if (depth_min_value > depth_max_value) {
		alert(translations.titleIncorrectDepthRange);
		var min_value = parseFloat($('#depth_left_hidden').val());
		$('#depth_from').val((min_value.toFixed(2)) + '%');
		return false;
	} else if (depth_value < default_depth_min) {
		alert(translations.titleIncorrectDepthRange);
		$('#depth_from').val(default_depth_min + "%");
		depth_slider_render(default_depth_min, depth_max_value, true);
		return false;
	}

	$('#depth_left_hidden').val(depth_min_value);
	$('#depth_right_hidden').val(depth_max_value);

	depth_slider_render(depth_min_value, depth_max_value, true, filterLabel);
}

function replace_depth_to(ele,depth_max,filterLabel) {
	if (jQuery('#depth_to').val() == '') {
		var max_value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}
    
	var depth_min_value = parseFloat($('#depth_from').val());
    var depth_max_value = parseFloat(jQuery('#depth_to').val());
	
	if (isNaN(depth_max_value) != false) {
		var max_value = default_depth_max;
		alert(translations.titlePleaseEnterValueInNumber);
		jQuery('#depth_to').val(max_value + '%');
        return false;
	} else if (depth_min_value > depth_max_value) {
		alert(translations.titleIncorrectDepthRange);
		var max_value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((max_value.toFixed(2)) + '%');
		return false;
	} else if (depth_max_value > default_depth_max) {
		$('#depth_to').val(default_depth_max + "%");
		depth_slider_render(depth_min_value, default_depth_max, true);
		return false;
	}

	$('#depth_right_hidden').val(depth_max_value);
	$('#depth_left_hidden').val(depth_min_value);

	depth_slider_render(depth_min_value, depth_max_value, true, filterLabel);
}
/*** End ***/

/*** Ratio Slider Filter Start ***/
function getRatioCalibArray(ratio_min,ratio_max) {  
  var ratio = [];
  for(i = parseFloat(ratio_min); i < parseFloat(ratio_max); i = i + 0.01){
  	var dec = i.toFixed(2);
  	ratio.push(dec);
  }
  return ratio;
}

function ratio_slider_render(min_ratio, max_ratio, option, filterLabel) {
    var ratio = getRatioCalibArray(default_ratio_min,default_ratio_max);
	var minRatio = getClosestNum(min_ratio, ratio);
	var maxRatio = getClosestNum(max_ratio, ratio);
	var ratio_min = get_index(minRatio, ratio);	
	var ratio_max = get_index(maxRatio, ratio);

    //session depth filter selected
     var isSelected = false;
     if(parseFloat(min_ratio) != parseFloat(default_ratio_min) || parseFloat(max_ratio) != parseFloat(default_ratio_max)){
       isSelected = true;
     }

     var filterValues = filterLabel+': '+min_ratio+' - '+max_ratio;
     setSelectedFilter(filterValues,"ratio_slider_render('"+parseFloat(default_ratio_min)+"', '"+parseFloat(default_ratio_max)+"','true')",isSelected,'ratio');
     //end
  
	jQuery("#tps_ratio_slider").slider({
		range: true,
		min: 0,
		max: ratio.length - 1,
		values: [ratio_min, ratio_max],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#ratio_from").val(ratio[parseFloat(ui.values[0])]);
			$('#ratio_left_hidden').val(ratio[parseFloat(ui.values[0])]);
			$('#ratio_to').val(ratio[parseFloat(ui.values[1])]);
			$('#ratio_right_hidden').val(ratio[parseFloat(ui.values[1])]);
		},
		change: function(event, ui) {
            var resetFlag = checkResetFlag();
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {			
                $("#ratio_from").val(ratio[parseFloat(ui.values[0])]);
                $('#ratio_left_hidden').val(ratio[parseFloat(ui.values[0])]);
                $('#ratio_to').val(ratio[parseFloat(ui.values[1])]);
                $('#ratio_right_hidden').val(ratio[parseFloat(ui.values[1])]);
             
                //applied filter start
                 var isSelected = false;                
                 if(ratio[parseFloat(ui.values[0])] != parseFloat(default_ratio_min) || ratio[parseFloat(ui.values[1])] != parseFloat(default_ratio_max)){
                       isSelected = true;
                 }
                var filterValues = translations.titleRatio+': '+ratio[parseFloat(ui.values[0])] +' - '+ratio[parseFloat(ui.values[1])];
                setSelectedFilter(filterValues,"ratio_slider_render('"+default_ratio_min+"', '"+default_ratio_max+"','true')",isSelected,'ratio');
                updateSessionFilters(session_variable+'-filters',translations.titleRatio,ratio[parseFloat(ui.values[0])]+","+ratio[parseFloat(ui.values[1])]);

                if(resetFlag != 'true'){
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');		
                  graphqlDataCall();     
                }
			}
		}

	});

	var start_limit = parseFloat(min_ratio);
	var end_limit = parseFloat(max_ratio);

	$("#ratio_from").val(start_limit.toFixed(2));
	$("#ratio_to").val(end_limit.toFixed(2));

	$('#ratio_left_hidden').val(min_ratio);
	$('#ratio_right_hidden').val(max_ratio);
}

function replace_ratio_from(ele,min_ratio,filterLabel) {    
	if($('#ratio_from').val() == '') {
		var min_value = parseFloat($('#ratio_left_hidden').val());
		$('#ratio_from').val((min_value.toFixed(2)));
		return false;
	} else {
		var ratio_value = parseFloat($('#ratio_from').val());
		var hidden_ratio_value = $('#ratio_left_hidden').val();
	}
	
	var ratio_min_value = parseFloat($('#ratio_from').val());
	var ratio_max_value = parseFloat($('#ratio_to').val());
	
	if(isNaN(ratio_min_value) != false) {
		var value = parseFloat(default_ratio_min);
		alert(translations.titlePleaseEnterValueInNumber);
		$('#ratio_from').val(value);
        return false;
	} else if (ratio_min_value > ratio_max_value) {
		alert(translations.titleIncorrectRatioRange);
		var min_value = parseFloat($('#ratio_left_hidden').val());
		$('#ratio_from').val(min_value.toFixed(2));
		return false;
	} else if (ratio_value < default_ratio_min) {
		alert(translations.titleIncorrectRatioRange);
		$('#ratio_from').val(default_ratio_min);
		ratio_slider_render(default_ratio_min, ratio_max_value, true);
		return false;
	}

	$('#ratio_left_hidden').val(ratio_min_value);
	$('#ratio_right_hidden').val(ratio_max_value);

	ratio_slider_render(ratio_min_value, ratio_max_value, true,filterLabel);
}

function replace_ratio_to(ele,max_ratio,filterLabel) {
	if (jQuery('#ratio_to').val() == '') {
		var max_value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val(value.toFixed(2));
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_to').val());
		var hidden_ratio_value = $('#ratio_right_hidden').val();
	}
    
	var ratio_min_value = parseFloat($('#ratio_from').val());
    var ratio_max_value = parseFloat(jQuery('#ratio_to').val());
	
	if (isNaN(ratio_max_value) != false) {
		var max_value = default_ratio_max;
		alert(translations.titlePleaseEnterValueInNumber);
		jQuery('#ratio_to').val(max_value);
        return false;
	} else if (ratio_min_value > ratio_max_value) {
		alert(translations.titleIncorrectRatioRange);
		var max_value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val(max_value.toFixed(2));
		return false;
	} else if (ratio_max_value > default_ratio_max) {
		$('#ratio_to').val(default_ratio_max);
		ratio_slider_render(ratio_min_value, default_ratio_max, true);
		return false;
	}

	$('#ratio_right_hidden').val(ratio_max_value);
	$('#ratio_left_hidden').val(ratio_min_value);

	ratio_slider_render(ratio_min_value, ratio_max_value, true, filterLabel);
}
/*** End ***/

/*** Diamond Carat Filter Start ***/
function getCaratCalibArray(minDiamondCarat,maxDiamondCarat) {
  var carat = [];
  for (i = parseFloat(minDiamondCarat); i < parseFloat(maxDiamondCarat); i = i + 0.01) {
  	var dec = i.toFixed(2);
  	carat.push(dec);
  }  
  // for (i = 1; i < parseFloat(maxDiamondCarat); i = i + 0.1) {
  // 	var dec = i.toFixed(2);
  // 	carat.push(dec);
  // }
  carat.push(maxDiamondCarat);
  return carat;
}
  
function carat_slider_render(min_carat, max_carat, option, filterLabel) { 
    var carat = getCaratCalibArray(default_carat_min,default_carat_max);
  
    var minCarat = getClosestNum(min_carat, carat);
	var maxCarat = getClosestNum(max_carat, carat);   
	var carat_min = get_index(minCarat, carat);	
	var carat_max = get_index(maxCarat, carat);      
  
    var isSelected = false;       
    //session carat filter selected         
     if(parseFloat(min_carat) != default_carat_min || parseFloat(max_carat) != default_carat_max){
       isSelected = true;
     }            
    var caratFilterUnit = "ct.";
    var filterValues = filterLabel+': '+min_carat + ' '+caratFilterUnit+' - '+max_carat + ' '+caratFilterUnit;
       
     setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
     //end
  
	jQuery("#tps_carat_slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [carat_min, carat_max],
        step: 1,
		slide: function(event, ui) {    
            emptyResultDiv();          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected            
			// if ((parseFloat(min_carat) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(max_carat) < parseFloat(carat[parseInt(ui.values[1])]))) {
			// 	return false;
			// }
          
			$("#carat_from").val(carat[parseInt(ui.values[0])]+' '+caratFilterUnit);
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])]+' '+caratFilterUnit);
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);          
		},
		change: function(event, ui) {   
            var resetFlag = checkResetFlag();
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {                  				
                //applied filter code start here   
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != parseFloat(default_carat_min) || carat[parseInt(ui.values[1])] != parseFloat(default_carat_max)){
                       isSelected = true;
                 }    
                                    
                  var caratLeft = carat[parseInt(ui.values[0])];
                  var caratRight = carat[parseInt(ui.values[1])];

                  $("#carat_from").val(caratLeft+' '+caratFilterUnit);
                  $('#carat_left_hidden').val(caratLeft);
                  $('#carat_to').val(caratRight+' '+caratFilterUnit);
                  $('#carat_right_hidden').val(caratRight);                       
                             
                  var filterValues = filterLabel+': '+caratLeft+ ' '+caratFilterUnit+' - '+caratRight+ ' '+caratFilterUnit;
                   
                  setSelectedFilter(filterValues,"carat_slider_render('"+default_carat_min+"', '"+default_carat_max+"','true','"+filterLabel+"')",isSelected,'carat');
                  //end 

                  updateSessionFilters(session_variable+'-filters',filterLabel, caratLeft+","+caratRight);
                  if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
    				jQuery('#pagination').val('');   
                    graphqlDataCall();   
                  }
			}
           
		}

	});
    
    min_carat = min_carat ? min_carat : default_carat_min;
    $("#carat_from").val(min_carat+' '+caratFilterUnit);
    $("#carat_to").val(max_carat+' '+caratFilterUnit);
    $('#carat_left_hidden').val(min_carat);
    $('#carat_right_hidden').val(max_carat);    
}

function replace_carat_from(ele,min_carat,filterLabel) {   
	var settingSelected = $("#setting").val();
    var caratFilterUnit = "ct.";
	if ($('#carat_from').val() == '') {
		var value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		$('#carat_from').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat($('#carat_from').val()).toFixed(2);
	}
	
    var carat_min_value = parseFloat($('#carat_from').val());
	var carat_max_value = parseFloat($('#carat_to').val());
 
	if (isNaN(carat_min_value) != false) {
        value = parseFloat(default_carat_min).toFixed(2); 
        alert(translations.titlePleaseEnterValueInNumber);        
		$('#carat_from').val(value +' '+caratFilterUnit);
	} else if (carat_min_value > carat_max_value) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else if (carat_value < default_carat_min) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_from').val((parseFloat(default_carat_min).toFixed(2))+" "+caratFilterUnit);
		carat_slider_render(default_carat_min, carat_max_value, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) { 
        alert(translations.titleCanMatchWithDiamond+' '+carat_value);      	
		$('#carat_from').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	}
	$('#carat_left_hidden').val(carat_min_value);
	$('#carat_right_hidden').val(carat_max_value);
    
	carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}

function replace_carat_to(ele,max_carat,filterLabel) {  
	var settingSelected = $("#setting").val();
    var caratFilterUnit = "ct.";
	if ($('#carat_to').val() == '') {
		var value = parseFloat($('#carat_right_hidden').val()).toFixed(2);
		$('#carat_to').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat($('#carat_to').val()).toFixed(2);
	} 
  
    var carat_max_value = parseFloat($('#carat_to').val());
	var carat_min_value = parseFloat($('#carat_from').val());
    
	if (isNaN(carat_max_value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2); 
        alert(translations.titlePleaseEnterValueInNumber);
		$('#carat_to').val(carat_max_value+' '+caratFilterUnit);
	} else if (parseFloat(carat_max_value) > parseFloat(default_carat_max)) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	} else if (carat_min_value > carat_max_value) {	
        alert(translations.titleIncorrectCaratRange);
		$('#carat_to').val(hidden_carat_value+' '+caratFilterUnit);
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
        alert(translations.titleCanMatchWithDiamond+' '+carat_value);		
		$('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	}
   
	$('#carat_right_hidden').val(carat_max_value);
	$('#carat_left_hidden').val(carat_min_value);

	carat_slider_render(carat_min_value, carat_max_value, true, filterLabel);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 2500 && i <= maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 2500; (i < 5000 && i <= maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 5000; (i < 6000 && i <= maxDiamondPrice); i = i+15) {
    price.push(i);
  };
  for (var i = 6000; (i < 7000 && i <= maxDiamondPrice); i = i+20) {
    price.push(i);
  };
  for (var i = 7000; (i < 8000 && i <= maxDiamondPrice); i = i+25) {
    price.push(i);
  };
  for (var i = 8000; (i < 9000 && i <= maxDiamondPrice); i = i+30) {
    price.push(i);
  };
  for (var i = 9000; (i < 10000 && i <= maxDiamondPrice); i = i+35) {
    price.push(i);
  };
  for (var i = 10000; (i < 15000 && i <= maxDiamondPrice); i = i+40) {
    price.push(i);
  };
  for (var i = 15000; (i < 25000 && i <= maxDiamondPrice); i = i+50) {
    price.push(i);
  };
  for (var i = 25000; (i < 50000 && i <= maxDiamondPrice); i = i+100) {
    price.push(i);
  };
  for (var i = 50000; (i < 80000 && i <= maxDiamondPrice); i = i+200) {
    price.push(i);
  };
  for (var i = 80000; (i < 100000 && i <= maxDiamondPrice); i = i+500) {
    price.push(i);
  };
  for (var i = 100000; (i < 200000 && i <= maxDiamondPrice); i = i+1000) {
    price.push(i);
  };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    graphqlDataCall();
                 }
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);
                
                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val('');                
                     setTimeout(function(){
                       graphqlDataCall();
                     }, 10); 
                   }else{                     
                     updateSessionFilters(session_variable+'-filters',filterLabel, default_price_min+","+default_price_max);  
                   }
                
                   setTimeout(function(){
                     option = true;
                   }, 25); 
                   return false;
                }
              slide = '';
            }
             
        });
  		  
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);  		 
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_max_price);
		return false;
	} else {
		var price_min = jQuery('#price_from').val();
	}
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
	var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
	if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
		jQuery('#price_from').val(formatted_min_price);
        return false;
	} else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);		
		jQuery('#price_from').val(formatted_min_price);
		return false;
	} else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
		price_slider_render(default_price_min, price_max_value, false, filterLabel);
		return false;
	}

	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
	if ($('#price_to').val() == ''){
		var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		$('#price_to').val(formatted_min_price);        
		return false;
	} else {
		var price_max = $('#price_to').val();        
	}

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
	if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
		jQuery('#price_to').val(formatted_max_price);
        return false;
	} else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value == '') {
		jQuery('#price_from').val(price_min_value);
	}

	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace(/[^\d\.]/g, '');
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');
    price = price.replace(/\./g, '');   
  }
  return price;
}
/*** Diamond Price Filter End ***/

/*** Get Slider Range Filter Min, Max Values ***/
function getFilterValues(min_value,max_value,filter) {
  var filterArray = getFilterArray(filter);

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){     
    if(store_lang == 'de'){
       if(i == min_value){
        selected_values.push(cut);
      }
      if(i == max_value-1){
        selected_values.push(cut);
      }
    }else{
      if(i == min_value){
        selected_values.push(key);
      }
      if(i == max_value-1){
        selected_values.push(key);
      }
    }
    i++;     
  });
  
  return selected_values;
}
/*** End ***/

/*** Get Selected Slider Range Filter Values ***/
function getSelectedRangeFilterValues(min_value,max_value,filter,default_value) {
  var filterArray = getFilterArray(filter);

  var i = 0;
  var selected_values = '';
  $.each(filterArray, function(key,cut){   
    if(min_value != 0 || max_value != default_value){
      if(i >= min_value && i <= max_value-1){
          if(i == max_value-1){
            selected_values += key;
          }else{
            selected_values += key+',';
          }        
        }
        i++;  
    }       
  });
  
  return selected_values;
}
/*** End ***/

/*** Get Filter Array Values ***/
function getFilterArray(filter) {
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array;  
  }else if(filter == 'polish'){
    filterArray = polish_array;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }
  return filterArray;
}
/*** End ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyResultDiv(flag){
  var diamond_active_tab = jQuery('#diamond_active_tab').val();  
    
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');

  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html('');
  jQuery('.tps-'+diamond_active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html('');

  getAllDiamonds();
}
/*** End ***/

/*** Show Listing View Loader Start ***/
function showLoader(active_tab) {  
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').css('display','block');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').css('display','block');
}
/*** Show Listing View Loader End ***/

/*** Sort Filter ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  var sort_field_list = sort_by.replace('_', '-');
  
  jQuery('#sort_call').val(sort_by); 
  jQuery('#sort_dir').val(sort_type);

  if(sort_type=="asc"){
      sort_order = translations.titleSortLowToHigh;
      jQuery('.tps-sort-icon-'+sort_field_list).addClass('tps-arrow-down').removeClass('tps-arrow-up');
  }else{
      sort_order = translations.titleSortHightToLow;
      jQuery('.tps-sort-icon-'+sort_field_list).removeClass('tps-arrow-down').addClass('tps-arrow-up');
  }
  jQuery('.tps-sort-by-value').html('<span>'+sort_title+ ' ('+sort_order+')</span>');
  
  jQuery('.tps-sort-option').removeClass('active');
  var sort_field_grid = sort_by+'_'+sort_type.toLowerCase();
  jQuery('.'+sort_field_grid).addClass('active');

  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');

  //store sorting in session
  var session_variable = jQuery("#session_variable").val();
  updateSessionFilters(session_variable+'-other-data','sort-by', sort_by);
  updateSessionFilters(session_variable+'-other-data','sort-direction', sort_type);
  graphqlDataCall();
 
});
/*** End ***/

/***Diamond List View Sort Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();  
	var sortorder = '';

	jQuery('.tps-sort-icon').each(function() {
		if (jQuery(this).hasClass('tps-arrow-up')) {
			jQuery(this).removeClass('tps-arrow-up').addClass('tps-arrow-down');
		}
	});

	if (((mySelection[1] == sorting) && (mySelection[2] == 'asc')) || mySelection.length == 0) {
		sortorder = 'desc';
		jQuery(className).find('i').removeClass('tps-arrow-down').addClass('tps-arrow-up');
	} else {
		sortorder = 'asc';
		jQuery(className).find('i').addClass('tps-arrow-down').removeClass('tps-arrow-up');
	}

    //change grid view dropdown value    
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value');
    jQuery('.tps-sort-by-value').text(sort_text);   

    jQuery('.tps-sort-option').removeClass('active');
    var sort_field_grid = sorting+'_'+sortorder;
    jQuery('.'+sort_field_grid).addClass('active');
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);

	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
  
    //store sorting in session
    var session_variable = jQuery("#session_variable").val();
    updateSessionFilters(session_variable+'-other-data','sort-by', mySelection[1]);
    updateSessionFilters(session_variable+'-other-data','sort-direction', mySelection[2]);
	graphqlDataCall();
}
/*** End ***/

/*** Graphql Call To Get Diamond Data ***/  
function graphqlDataCall(resetSearchCertificate){ 
  if(typeof resetSearchCertificate == 'undefined'){
    jQuery("#search-by-certificate-input").val('');
    jQuery("#Certificate_Number_Stock_Number-container").remove();
    
    //set value in session 
    var session_variable = jQuery("#session_variable").val();
    updateSessionFilters(session_variable+'-filters', 'search-certificate', '');
  }
  jQuery('.diamond-grid-row').removeClass('tps-recent-viewed-diamond');
  jQuery('.diamond-list-row').removeClass('tps-recent-viewed-diamond');
  var diamond_active_tab = jQuery('#diamond_active_tab').val();
  showLoader(diamond_active_tab); 
  jQuery(".tps-dia-count").html("(<span class='tps-dia-count-loader'></span>)"); //display diamond count loader before diamonds load
  jQuery(".tps-recent-diamonds-tab").addClass("tps-tab-disabled");
  jQuery(".tps-compare-diamonds-tab").addClass("tps-tab-disabled");
  
  var page_no = jQuery('#page_no').val(); 
  var diamond_type = jQuery('#diamond_type').val(); 
  var dia_shape = jQuery('#dia_shape').val();
  var dia_fancy_color = jQuery('#dia_fancy_color').val();
  var dia_report = jQuery('#dia_report').val(); 
  var dia_media = jQuery('#dia_media').val(); 
  var carat_min = jQuery("#carat_left_hidden").val();
  var carat_max = jQuery("#carat_right_hidden").val();
  var price_min = jQuery("#price_left_hidden").val();
  var price_max = jQuery("#price_right_hidden").val();  
  var color_min = jQuery('#color_min_value').val();
  var color_max = jQuery('#color_max_value').val();
  var clarity_min = jQuery('#clarity_min_value').val();
  var clarity_max = jQuery('#clarity_max_value').val();
  var cut_min = jQuery('#cut_min_value').val();
  var cut_max = jQuery('#cut_max_value').val();
  var fluorescence_min = jQuery('#fluorescence_min_value').val();
  var fluorescence_max = jQuery('#fluorescence_max_value').val();
  var polish_min = jQuery('#polish_min_value').val();
  var polish_max = jQuery('#polish_max_value').val();
  var symmetry_min = jQuery('#symmetry_min_value').val();
  var symmetry_max = jQuery('#symmetry_max_value').val();
  var table_min = jQuery("#table_left_hidden").val();
  var table_max = jQuery("#table_right_hidden").val();
  var depth_min = jQuery("#depth_left_hidden").val();
  var depth_max = jQuery("#depth_right_hidden").val();
  var ratio_min = jQuery("#ratio_left_hidden").val();
  var ratio_max = jQuery("#ratio_right_hidden").val();
  var sort_call = jQuery('#sort_call').val(); 
  var sort_dir = jQuery('#sort_dir').val();
  var supplier_name = jQuery('#supplier_name').val();
  var bulk_page_data = getBulkPageDataValuesFromSession();

  if(diamond_type == 'white' || diamond_type == 'fancy'){
     diamondListingApi = rapnetDiamondListingApi;
  }else{
     diamondListingApi = labDiamondListingApi;
  }    
  var dia_color_flag = jQuery("#diamond_meta_type").val() == "lab-color" ? "fancy" : "";
  //get values of diamond color selected filters in english 
  var dia_color = '';
  if(session_variable == 'ringbuilder-natural-white-diamond' || session_variable == 'ringbuilder-lab-white-diamond'){
    dia_color = getSelectedRangeFilterValues(color_min,color_max,'color',default_max_color);
  }else if(session_variable == 'ringbuilder-lab-color-diamond' || session_variable == 'ringbuilder-natural-color-diamond'){
    dia_color = "";
  }
  //end  

  //get values of diamond clarity selected filters in english 
  var dia_clarity = getSelectedRangeFilterValues(clarity_min,clarity_max,'clarity',default_max_clarity);   
  //end

  //get values of diamond cut selected filters in english 
  var dia_cut = getSelectedRangeFilterValues(cut_min,cut_max,'cut',default_max_cut);  
  //end

  //get values of diamond fluorescence selected filters in english 
  var dia_fluorescence = getSelectedRangeFilterValues(fluorescence_min,fluorescence_max,'fluorescence',default_max_flour); 
  //end  
  
  //get values of diamond polish selected filters in english 
  var dia_polish = getSelectedRangeFilterValues(polish_min,polish_max,'polish',default_max_polish);   
  //end
   
  //get values of diamond symmetry selected filters in english 
  var dia_symmetry = getSelectedRangeFilterValues(symmetry_min,symmetry_max,'symmetry',default_max_symm); 
  //end  
  
  //query parameters for graphql call
  var postdata = JSON.stringify({ query:`{
                  ${diamondListingApi}(page: "` +
              page_no +
              `", shapes:"` +
              dia_shape +
              `", color:"`+ dia_color +
              `", fancyColor:"`+ dia_fancy_color + `", colorFlag:"` + dia_color_flag +
              `", carat:"` + carat_min + `, ` + carat_max +
              `", clarity:"` +
              dia_clarity +
              `", symmetry:"` + dia_symmetry + `", polish:"` + dia_polish +
              `", price:"` + price_min + `, ` + price_max +
              `", cut:"` +
              dia_cut +
              `", fluoroscence:"` +
              dia_fluorescence +
              `",table:"` + table_min + `,` + table_max +
              `",depthPer:"` + depth_min + `,` + depth_max +
              `",ratio:"` + ratio_min + `,` + ratio_max +
              `",isImage:"` + dia_media + `",lab:"` + dia_report +
              `", diamondType:"` + diamond_type +
              `", currencyFlag:"` + theme.shopCurrency +
              `", orderBy:"` + sort_call + `", sortBy:"` + sort_dir +
              `")
                  {
                   dataCount
                   diamondsReturned
                   pageNo
                   diamond{
                   diamondId                     
                    shape 
                    caratWeight  
                    color 
                    fancyColor 
                    fancyColorIntensity
                    fancyColorOvertone 
                    clarity 
                    cut 
                    symmetry 
                    polish 
                    deptPerc 
                    tablePerc 
                    length 
                    width 
                    depth 
                    ratio 
                    measurement 
                    girdle
                    girdleMin 
                    girdleMax 
                    girdleCondition 
                    culet 
                    culetCondition  
                    flourIntensity  
                    certificateFile 
                    lab  
                    finalPriceAud
                    finalPrice 
                    originalTotalPriceEur
                    pricePerCtEur 
                    certificateNumber 
                    stockNumber 
                    diamondImage  
                    diamondVideo  
                    diamondType 
                    currencyCode 
                    currencySymbol
                   }
                  }
                  }
                  `});            
    abortAjax(xhr);
      
    //ajax graphql call for diamonds
    xhr = jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) {    
        var dia_data = response.data[diamondListingApi].diamond;  
        
        var dia_count;
        if(response.data[diamondListingApi].dataCount == null){
          var dia_count = 0;
          var dia_return = 0;
        }else{
          var dia_count = response.data[diamondListingApi].dataCount;
          var dia_return = response.data[diamondListingApi].diamondsReturned;
        }

        getDiamondListView(dia_data,dia_count,dia_return,bulk_page_data);          
        
        //diamond info focus return from diamond detail page  
        var session_variable = jQuery("#session_variable").val();
        var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
        if(session_other_data != '' && session_other_data != null){
          if(session_other_data['Single-Recent-Diamond'] != null && session_other_data['Single-Recent-Diamond'] != '' && session_other_data['Single-Recent-Diamond'] != undefined){
            var recentDiamond = session_other_data['Single-Recent-Diamond'][0];
            var ViewType = session_other_data['View-Type'][0];
            focusRecentDiamond(recentDiamond,ViewType);            
          }     
        }
        //end       
      }
    });      

}
/*** End ***/

/*** Check Bulk Page Data Flag For Back TO Serach Diamonds start ***/
function getBulkPageDataValuesFromSession() {
  var bulk_page_data = 'no';
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Recent-Diamond-Page-No'] != undefined && session_other_data['Recent-Diamond-Page-No'][0] != ''){      
      var bulk_page_data = 'yes';
    }
  }
  return bulk_page_data;
}
/*** Check Bulk Page Data Flag For Back TO Serach Diamonds End ***/

/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/

/*** Focus Recently View Diamond Start ***/
function focusRecentDiamond(diamond_id,view_type) {
  if(view_type == 'list'){
     var target = '.diamond-list-item-'+diamond_id;
     openCloseDetailInfo(diamond_id,'all','list','open',target); 
  }else{
    var target = '.diamond-grid-item-'+diamond_id; 
  }
  
  $(target).addClass('tps-recent-viewed-diamond');
  $('html, body').animate({
        scrollTop: $(target).offset().top - 300
  }, 'slow'); 
  
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Diamond', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Diamond-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-diamond'); }, 1000);
}
/*** End ***/

/*** Diamonds Layout Start ***/
function getDiamondListView(allDiamondData,dia_count,dia_return,bulk_page_data){  
  var active_tab = jQuery('#diamond_active_tab').val();
  var page_no = jQuery('#page_no').val(); 
  var pagination = jQuery("#pagination").val();
  
  jQuery(".tps-dia-count").text("("+addCommas(dia_count)+")");
  jQuery(".tps-total-diamonds").text(addCommas(dia_count));
  jQuery("#total_product").val(dia_count);
  jQuery(".tps-load-more-button-section").show();
  jQuery(".tps-recent-diamonds-tab").removeClass("tps-tab-disabled");
  jQuery(".tps-compare-diamonds-tab").removeClass("tps-tab-disabled");
    
  var compare_diamonds = [];      
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != undefined && session_other_data['Compare-Diamonds'] != null){
      if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
        var compare_diamonds = session_other_data['Compare-Diamonds'];
      }
    }
  }
    
  //Diamond List View
  var diaListView = '';
  var diaGridView = '';

  var tableHeadWidthlist = Math.round(100/9);
  jQuery('.table-head').css('width', tableHeadWidthlist + '%');
  
  if(allDiamondData != '' && allDiamondData != null){     
    $.each(allDiamondData, function(i, diamondData) { 
       diaListView += getDiamondListingViewLayout(diamondData,compare_diamonds,active_tab);
       diaGridView += getDiamondListingGridLayout(diamondData,compare_diamonds,active_tab);
    });    
  }else{
    jQuery(".tps-load-more-button-section").hide();
    
    diaListView += '<span class="tps-no-diamond-found">'+translations.titleNoDiamondFound+'</span>';
    diaGridView += '<span class="tps-no-diamond-found">'+translations.titleNoDiamondFound+'</span>';

    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').addClass('tps-no-diamonds-found');
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').addClass('tps-no-diamonds-found');
  }

  if(page_no == 1){
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html(diaListView);
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(diaGridView);    
  }else{
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').append(diaListView);
    jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').append(diaGridView);
  }
  
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').hide();
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').hide();
  //End  

  var pageid = parseInt(page_no)+1;  
  jQuery('#page_no').val(pageid);
  
  //Load More Button Hide Show 
  if(dia_return == undefined){ 
    jQuery(".tps-load-more").hide();
  }else if(dia_return < diamondResultPageLimit || dia_count == diamondResultPageLimit){
    var previous_page_no = parseInt(page_no)-1;
    var total_previous_diamonds = previous_page_no*diamondResultPageLimit;
    var diamonds_viewed = parseInt(total_previous_diamonds)+parseInt(dia_return);
    
    jQuery('.tps-total-diamonds-displays').html(addCommas(diamonds_viewed));
    jQuery(".tps-load-more").hide();
  }else{        
    if(bulk_page_data == 'yes'){      
      var diamonds_viewed = dia_return;
    }else{
      var diamonds_viewed = page_no*diamondResultPageLimit;
    }    
    jQuery('.tps-total-diamonds-displays').html(addCommas(diamonds_viewed));
    jQuery(".tps-load-more").show();
  }  
  //end.
  
  // scrollFlag = 0; 
}
/*** End ***/

/*** Diamonds Listing Grid Layout Start ***/
function getDiamondListingGridLayout(diamondData,compare_diamonds,active_tab) {
  var page_no = jQuery('#page_no').val(); 
  var currency_rate = Shopify.currency.rate;
  var diamond_id = diamondData.diamondId;
  var diamond_shape = diamondData.shape;
  var diamond_type = getDiamondType(diamondData.diamondType);   
  var diamond_title = getDiamondName(diamondData,diamond_type);   
  var diamond_certificate_url = getCertificateUrl(diamondData); 
  var final_price = diamondData.finalPriceAud;   
  var diamond_price = getDiamondPrice(currency_rate,final_price);   

  var compareClass = '';
  if($.inArray(diamondData.diamondId.toString(), compare_diamonds)!=(-1)){
    var compareClass = 'active';            
  }

  diaGrid = '';
  if(active_tab == 'compare'){
    diaGrid += '<li class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'" data-compare-id="' + diamond_id + '">';
  }else{
    diaGrid += '<li class="tps-diamondlist-result-grid-view-item diamond-grid-row diamond-grid-item-'+diamondData.diamondId+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">';
  }
  if(diamondData.diamondType == 'lab'){
    diaGrid += '<div class="tps-diamondlist-item-badget-span">';
    diaGrid += '<ul class="tps-diamondlist-item-badget-span-list">';
    diaGrid += '<li class="tps-diamondlist-result-badget-info tps-diamondlist-result-badget-info-lab">'+translations.titleLab+'</li>';
    if(diamondData.process != '' && diamondData.process != null){
      diaGrid += '<li class="tps-diamondlist-result-badget-info tps-diamondlist-result-badget-treatment">'+diamondData.process+'</li>';
    }
    diaGrid += '</ul>';
    diaGrid += '</div>';
  }
  diaGrid += '<div class="tps-diamondlist-item-info-span">';
  diaGrid += '<ul class="tps-diamondlist-item-info-span-list">';
  diaGrid += '<li class="tps-diamondlist-result-grid-info">';
  diaGrid += '<span class="tps-diamondlist-result-grid-info-span tps-diamond-info-span" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`grid`,`open`,event);">info</span>';
  diaGrid += '</li>';
  if(active_tab == 'all'){
    diaGrid += '<li class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' '+compareClass+'" onclick="selectRow(this);event.stopPropagation();compareDiamonds(`'+diamond_id+'`);">';
    diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" onclick="event.stopPropagation();compareDiamonds(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
    diaGrid += '</li>';
  }else if(active_tab == 'compare'){
    diaGrid += '<li class="tps-diamondlist-result-grid-compare diamond-compare-'+diamondData.diamondId+' active">';
    diaGrid += '<input type="checkbox" class="tps-diamondlist-compare-chk diamond-checkbox-'+diamondData.diamondId+'" onclick="event.stopPropagation();removeCompare(`'+diamond_id+'`);" data-diamond-id="'+diamond_id+'" data-diamond-name="'+diamond_title+'" data-result-list-view-type="grid"><span class="tps-diamondlist-compare-span"></span>';
    diaGrid += '</li>';
  }
  diaGrid += '</ul>';
  diaGrid += '</div>';
  
  diaGrid += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">';
  diaGrid += '<div class="tps-diamondlist-item-media-div">';
  diaGrid += getDiamondImageLayout(diamondData,diamond_title);
  if(diamondData.diamondVideo != 'None' && diamondData.diamondVideo != ''){
    diaGrid += '<span class="tps-diamondlist-media-loader" style="display: none;"></span>';
    diaGrid += '<span class="tps-diamondlist-item-video-icon">video</span>';
    diaGrid += '<div class="tps-diamondlist-video-iframe-div tps-embed-media-container" style="opacity: 0;">';
    diaGrid += '</div>';
  }
  diaGrid += '</div>';
  diaGrid += '<div class="tps-diamondlist-result-grid-view-cn">'; 
  diaGrid += '<div class="tps-diamondlist-item-title">'+diamond_title+'</div>';
  diaGrid += '<div class="tps-diamondlist-item-meta-data">'; 
  diaGrid += getDiamondMetaInformation(diamondData);
  diaGrid += '</div>';          
  diaGrid += '<div class="tps-diamondlist-item-price">'+diamond_price+'</div>';          
  diaGrid += '</div>';
  diaGrid += '</a>';

  //diamond info layout start
   diaGrid += '<div class="tps-diamondlist-item-info tps-diamond-info-'+diamondData.diamondId+'" style="display:none;">';
   diaGrid += '<span class="tps-diamondlist-item-info-close tps-diamond-info-close" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`grid`,`close`,event);">close</span>';
   diaGrid += getDiamondInformationLayout(diamondData);
   diaGrid += '</div>';
  //end
  diaGrid += '<input type="hidden" id="tps_diamond_video_'+diamondData.diamondId+'" value="'+diamondData.diamondVideo+'">';
  diaGrid += '</li>';
  
  return diaGrid;
}
/*** End ***/

/*** Diamonds List View Layout Start ***/
function getDiamondListingViewLayout(diamondData,compare_diamonds,active_tab) {
  var page_no = jQuery('#page_no').val(); 
  var currency_rate = Shopify.currency.rate;
  var diamond_id = diamondData.diamondId;
  var diamond_shape = diamondData.shape;
  var diamond_type = getDiamondType(diamondData.diamondType);   
  var diamond_title = getDiamondName(diamondData,diamond_type);   
  var diamond_certificate_url = getCertificateUrl(diamondData); 
  var final_price = diamondData.finalPriceAud;   
  var diamond_price = getDiamondPrice(currency_rate,final_price);  
  
  if($.inArray(diamondData.diamondId.toString(), compare_diamonds)!=(-1)){
    var iconChk = 'checked';            
  }else{
    var iconChk = '';
  }
  
  var diaList = '';
  var tableHeadWidth = Math.round(100/9);
  
  if(active_tab == 'compare'){
    diaList += '<li class="tps-diamondlist-result-list-view-item diamond-list-row diamond-list-item-'+diamond_id+'" data-compare-id="'+diamond_id+'">';
  }else{
    diaList += '<li class="tps-diamondlist-result-list-view-item diamond-list-row diamond-list-item-'+diamond_id+'">';
  }
  
  diaList += '<div class="tps-desktop-table-row" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`list`,`open`,event);">';  

  if(active_tab == 'all'){
    diaList += '<span class="table-data table-data-compare" onclick="selectRow(this);event.stopPropagation();compareDiamonds(`'+diamond_id+'`);"style="width:'+tableHeadWidth+'%">';  
    diaList += '<i class="tps_checkbox"><input type="checkbox" value="'+diamondData.diamondId+'" data-product-id="'+diamondData.diamondId+'" data-role="none" class="diamond-checkbox-'+diamondData.diamondId+' grid_checkbox" name="idcompare'+diamondData.diamondId+'" data-diamond-name="'+diamond_title+'" value="'+diamondData.diamondId+'"  onclick="event.stopPropagation();compareDiamonds(`'+diamond_id+'`);" '+iconChk+'><span class="tps-diamondlist-compare-span"></span></i>';       
    diaList += '</span>';
  }else if(active_tab == 'compare'){
    diaList += '<span class="table-data table-data-compare" onclick="event.stopPropagation();removeCompare(`'+diamondData.diamondId+'`);" style="width:'+tableHeadWidth+'%"><a href="javascript:void(0)" onclick="event.stopPropagation();removeCompare(`'+diamondData.diamondId+'`);">X</a></span>';
  }
  diaList += '<span class="table-data table-data-shape-image" style="width:'+tableHeadWidth+'%"><span class="tps-shape-icon tps-shape-icon-'+diamond_shape.toLowerCase()+'"></span></span>';
  diaList += '<span class="table-data table-data-shape" style="width:'+tableHeadWidth+'%">'+diamond_shape+'</span>';
  diaList += '<span class="table-data table-data-carat" style="width:'+tableHeadWidth+'%">'+diamondData.caratWeight+'</span>';
  if(diamondData.color != ''){
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+diamondData.color+'</span>';
  }else{
    diaList += '<span class="table-data table-data-color" style="width:'+tableHeadWidth+'%">'+diamondData.fancyColor+'</span>';
  }
  diaList += '<span class="table-data table-data-clarity" style="width:'+tableHeadWidth+'%">'+diamondData.clarity+'</span>';
  diaList += '<span class="table-data table-data-report" style="width:'+tableHeadWidth+'%">'+diamondData.lab+'</span>';          
  diaList += '<span class="table-data table-data-price" style="width:'+tableHeadWidth+'%">'+diamond_price+'</span>';
  diaList += '<span class="table-data table-data-view tps-diamondlist-view-'+diamondData.diamondId+' tps-arrow-down" style="width:'+tableHeadWidth+'%"></span>';  
  diaList += '</div>';
  
  diaList += '<div class="tps-diamondlist-detail-info tps-diamond-detail-info-'+diamondData.diamondId+'" style="display:none;">';
  diaList += '<span class="tps-diamondlist-detail-view-close" data-id="'+diamondData.diamondId+'" onclick="openCloseDetailInfo(`'+diamond_id+'`,`'+active_tab+'`,`list`,`close`,event);">close</span>';
  diaList += '<div class="tps-diamondlist-item-quick-view-wrapper">';  
  diaList += '<div class="tps-diamondlist-detail-view-media">';
  diaList += getDiamondImageLayout(diamondData,diamond_title);  
  diaList += '</div>';

  //diamond info layout start
  diaList += '<div class="tps-diamondlist-detail-view-info-table">';
  diaList += '<div class="tps-diamondlist-detail-view-title">'+diamond_title+'</div>';
  diaList += '<div class="tps-diamondlist-detail-view-price">'+diamond_price+'</div>';
  diaList += '<div class="tps-diamondlist-detail-table-info">';
  diaList += getDiamondInformationLayout(diamondData);
  diaList += '</div>';
  diaList += '</div>';
  //end
  
  diaList += '<div class="tps-diamondlist-detail-view-btn-row">';
  diaList += '<a href="'+tps_config.urls.loose_diamond_detail+'?diamond_id='+diamondData.diamondId+'&diamond_type='+diamondData.diamondType+'" class="tps-diamondlist-detail-view-btn" data-id="'+diamondData.diamondId+'" data-page="'+page_no+'">'+translations.titleViewDiamond+'</a>';
  diaList += '</div>';
  
  diaList += '</div>';
  diaList += '</div>';
  
  diaList += '</li>';
  
  return diaList;
}
/*** End ***/


/*** Grid View On Image Hover 360 Video Display Start ***/ 
jQuery(document).on({
    mouseenter : function(e) {
        if (jQuery(window).width() > 1100) {
            var diamondItemDiv  = jQuery(this);
            var diamondID 	    = jQuery(this).attr("data-id");  
            
            if (diamondItemDiv.find('.tps-diamondlist-video-iframe').length < 1) {
                var diamondVideo = jQuery("#tps_diamond_video_"+diamondID).val();    
                if (diamondVideo != '' && diamondVideo != 'None') {
                    if (diamondVideo.indexOf("https://loupe360.com/diamond/") > -1){              
                      diamondVideo = diamondVideo.replace('/500/500', '/resp/true/autoplay');
                    }  
                    displayDiamondVideo(diamondItemDiv, diamondVideo);
                }
            } else if(diamondItemDiv.find('.tps-diamondlist-video-iframe').hasClass('video-loaded')) {
                switchDiamondImageAndVideo(diamondItemDiv, 'video');
            }	
        }
    },
}, '.tps-diamondlist-result-grid-view-item');
/*** Grid View On Image Hover 360 Video Display End ***/

/*** Grid View On Video Hover Out Image Display Start ***/ 
jQuery(document).on({
    mouseleave : function(e) {
        var diamondItemDiv  = jQuery(this);
        switchDiamondImageAndVideo(diamondItemDiv, 'image');
    },
}, '.tps-diamondlist-result-grid-view-item');
/*** Grid View On Video Hover Out Image Display End ***/ 

/*** Display Diamond 360 Video Start ***/
function displayDiamondVideo(diamondItemDiv, diamondVideoURL = '') {			
    //var iframeVideoHTML = `
        //<iframe src="${diamondVideoURL}" class="tps-diamondlist-video-iframe" width="${diamondItemDiv.outerWidth()}" height="${diamondItemDiv.outerHeight()}" />`;

    var iframeVideoHTML = `<embed class="tps-diamondlist-video-iframe" src="${diamondVideoURL}" type="text/html" width="${diamondItemDiv.outerWidth()}" height="${diamondItemDiv.outerHeight()}"><div class="tps-video-click-overlay"></div>`;
  
    diamondItemDiv.find('.tps-diamondlist-media-loader').show();
    diamondItemDiv.find('.tps-diamondlist-video-iframe-div').prepend(iframeVideoHTML);
    diamondItemDiv.find('.tps-diamondlist-video-iframe').bind('load', function(e) {
        if(!diamondItemDiv.find('.tps-diamondlist-video-iframe').hasClass('focus-moved')){
            var currentIframe = jQuery(e.target);
            var mediaDiv 	  = currentIframe.parents('.tps-diamondlist-item-media-div');			
            mediaDiv.find('.tps-diamondlist-media-loader').hide();
            mediaDiv.find('.tps-diamondlist-detail-img').css('opacity', 0);
            mediaDiv.find('.tps-diamondlist-video-iframe-div').css('opacity', 1);	
        } 
        diamondItemDiv.find('.tps-diamondlist-video-iframe').addClass('video-loaded');
    });
}
/*** Display Diamond 360 Video End ***/

/*** Switch Diamond Image And Video Start ***/
function switchDiamondImageAndVideo(diamondItemDiv, divType = 'image') {		
    if(divType == 'video') {	
        diamondItemDiv.find('.tps-diamondlist-video-iframe-div').css('opacity', 1);
        diamondItemDiv.find('.tps-diamondlist-detail-img').css('opacity', 0);
        diamondItemDiv.find('.tps-diamondlist-video-iframe').removeClass('focus-moved');
    } else {				
        jQuery('.tps-diamondlist-media-loader').hide();
        jQuery('.tps-diamondlist-video-iframe-div').css('opacity', 0);
        jQuery('.tps-diamondlist-detail-img').css('opacity', 1);
        diamondItemDiv.find('.tps-diamondlist-video-iframe').addClass('focus-moved');
    }		
}
/*** Switch Diamond Image And Video End ***/

/*** Diamonds Meta Information Layout Start ***/
function getDiamondMetaInformation(diamondData) {
  var metaInfo = '';
  if(diamondData.color != ''){
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.color+',</span>';
  }else{
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.fancyColor+',</span>';
  }    
  if(diamondData.clarity != '' && diamondData.clarity != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.clarity+',</span>';
  }
  if(diamondData.cut != '' && diamondData.cut != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.cut+',</span>';
  }     
  if(diamondData.polish != '' && diamondData.polish != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.polish+',</span>';
  }  
  if(diamondData.symmetry != '' && diamondData.symmetry != 'NA'){
    metaInfo += '<span class="tps-meta-data-item">'+diamondData.symmetry+'</span>';
  }  
  return metaInfo;
}
/*** End ***/

/*** Diamonds Image Layout Start ***/
function getDiamondImageLayout(diamondData,diamond_title) { 
  var session_variable = jQuery('#session_variable').val();
  var diamond_image = diamondData.diamondImage;
  var image = '';
  var diamondStockImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    if(session_variable == 'ringbuilder-natural-white-diamond' || session_variable == 'ringbuilder-lab-white-diamond'){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }
  });
  
  if(diamond_image != '' && diamond_image != 'NA' && diamond_image != 'N/A' && diamond_image != 'None'){
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" src="'+diamond_image+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" width="300" height="300">';
  }else{    
    image += '<img class="tps-diamondlist-detail-img" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" src="'+diamondStockImage[0]+'" width="300" height="300">';        
  }
  return image;
}
/*** Diamonds Layout Start ***/

/*** selectRow function to compare diamond  ***/  
function selectRow(row){
    var firstInput = row.getElementsByTagName('input')[0];
    firstInput.checked = !firstInput.checked;    
}
/*** End ***/

/*** Change Diamond Listing View Grid/List ***/
function changeResultView(viewType){
  jQuery('.tps-result-view').removeClass('active');
  jQuery('.tps-'+viewType+'-view').addClass('active');  
  
  if(viewType == 'list'){
    jQuery('.tps-diamond-list-view-container').css("display","block");
    jQuery('.tps-diamond-grid-view-container').css("display","none");
    jQuery('.tps-sort-section').css("display","none");
  }else{
    jQuery('.tps-diamond-grid-view-container').css("display","block");
    jQuery('.tps-diamond-list-view-container').css("display","none");
    if(jQuery('.tps-all-diamonds-tab').hasClass('active-tab')){
      jQuery('.tps-sort-section').css("display","block");
    }else{
      jQuery('.tps-sort-section').css("display","none");
    }
  }

  updateSessionFilters(session_variable+'-other-data','View-Type', viewType);  
}
/*** End ***/

/*** Diamond List & Grid View Detail Info Ope Close ***/
function openCloseDetailInfo(diamond_id,active_tab,display_type,action,ele) {    
  var active_tab = jQuery('#diamond_active_tab').val();
  if(display_type == 'grid'){  
    if(action == 'open'){
      jQuery('.tps-diamondlist-item-info').css("display", "none");
      jQuery('.tps-diamond-info-'+diamond_id).slideDown('slow');
    }else{
      jQuery('.tps-diamond-detail-info-'+diamond_id).slideUp('slow');
      jQuery('.tps-diamond-info-'+diamond_id).slideUp('slow');
    }      
  }else{
    
    if(jQuery('.diamond-list-item-'+diamond_id).hasClass("diamond-row-active")){
      action = 'close';
    }
   
     var container = $(".tps-diamondlist-item-quick-view-wrapper"); //diamond info container    
     // If the target of the click isn't the container
     if(!container.is(ele.target) && container.has(ele.target).length === 0){         
          if(action == 'open'){   
            jQuery('.tps-diamondlist-detail-info').slideUp('slow'); 
            jQuery('.tps-diamondlist-result-list-view-item').removeClass("diamond-row-active");
            
            jQuery('.diamond-list-item-'+diamond_id).addClass("diamond-row-active"); 
            jQuery('.tps-diamond-detail-info-'+diamond_id).slideDown('slow'); 
            jQuery('.tps-diamondlist-view-'+diamond_id).removeClass('tps-arrow-down').addClass('tps-arrow-up');  

            var target = '.diamond-list-item-'+diamond_id;
        
            //adjust scroll position when diamond info display        
            if(active_tab == 'recent' || active_tab == 'compare'){
              if(jQuery('#tps_diamond_list_view_container '+target).offset().top){
                jQuery('html, body').animate({
                  scrollTop: jQuery('#tps_diamond_list_view_container '+target).offset().top - 100
                }, 150); 
              }    
            }else{
              jQuery('html, body').animate({
                  scrollTop: jQuery(target).offset().top - 500
              }, 150); 
            }
               
            //end
            
          }else{
            jQuery('.table-data-view').removeClass("tps-arrow-up").addClass('tps-arrow-down');
            jQuery('.tps-diamondlist-detail-info').css("display", "none");            
            jQuery('.diamond-list-row').removeClass("diamond-row-active");
          }
     }         
  }  
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(resetSearchCertificate=false){
  var diamond_type = jQuery('#diamond_type').val();
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters'); 
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();

  var can_be_set_with = '';
  if(JSON.parse(localStorage.getItem("ring-selected-setting"))) {
    var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));
    var can_be_set_with = setting_info[0].setting_can_be_match_with;
    ringCanBeSetWith(can_be_set_with);
  }

  var tableTitle = translations.titleTable.replace(' %', '');
  var depthTitle = translations.titleDepth.replace(' %', '');    
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#dia_shape').val(can_be_set_with);    
    

    $('.tps-filter-fancy-color-li').removeClass('selected');
    $(".tps-filter-fancy-color-checkbox").prop('checked', false);
    $('#dia_fancy_color').val('');
    
    $('.tps-filter-report-li').removeClass('selected');
    $(".tps-filter-report-checkbox").prop('checked', false);
    $('#dia_report').val('');

    $('.tps-filter-media-li').removeClass('selected');
    $(".tps-filter-media-checkbox").prop('checked', false);
    $('#dia_media').val('');    
    if(resetSearchCertificate){
      jQuery('#search-by-certificate-input').val('');      
    }  

    carat_slider_render(default_carat_min, default_carat_max, true, translations.titleCarat); 
    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     
    clarity_slider_render(0, default_max_clarity, true, translations.titleClarity);
    cut_slider_render(0, default_max_cut, true, translations.titleCut);
    fluorescence_slider_render(0, default_max_flour, true, translations.titleFluorescence);
    polish_slider_render(0, default_max_polish, true, translations.titlePolish);
    symmetry_slider_render(0, default_max_symm, true, translations.titleSymmetry);   
    table_slider_render(default_table_min, default_table_max, true, tableTitle);
    depth_slider_render(default_depth_min, default_depth_max, true, depthTitle); 
    if(session_variable == 'ringbuilder-lab-white-diamond' || session_variable == 'lab-color-diamond'){
      ratio_slider_render(default_ratio_min, default_ratio_max, true, translations.titleRatio);
    }    
    if(session_variable == 'ringbuilder-natural-white-diamond' || session_variable == 'ringbuilder-lab-white-diamond'){
      color_slider_render(0, default_max_color, translations.titleColor);
    }
    jQuery(".tps-sort-option.final_price_asc.asc").trigger('click');
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');   
    graphqlDataCall(resetSearchCertificate);

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
    
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Pagination on infinite scroll Start ***/
// var scrollFlag = 0; 
// $(window).bind('scroll', function() {  
//   var dia_report_no = jQuery("#tps_search_by_report_no").val();   
         
//       if($(window).scrollTop() >= $('.tps-diamond-list-grid-container').offset().top + $('.tps-diamond-list-grid-container').outerHeight() - window.innerHeight) {
//         if(scrollFlag == 0){      
//             var lastid = jQuery('#page_no').val();   
//             var pagesize = jQuery("#page_no").val();
//             var totalcount = jQuery("#total_product").val();
//             var totalno = Math.ceil(totalcount/20);
//             jQuery(".listingtab").removeClass("active_tab");
//             jQuery(".shopify_main_pop_div").removeClass('active');  
//             jQuery(".alldiamonds_tab").addClass("active_tab");
          
    
//             if(totalno < pagesize){
//                 return false;
//             }
//             jQuery('#pagination').val('true');
//             scrollFlag = 1;
//             graphqlDataCall();
//         }
//       }
    
// });
/*** End ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Report' || key == 'Media' || key == 'Colour'){    
        if(value != ''){
          var inputValues = value.toString();
          if(key == 'Colour'){
            $('#dia_fancy_color').val(inputValues);
          }else{
            $('#dia_'+inputKey).val(inputValues);
          }          
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'search-certificate'){
      var inputValues = value.toString();
      $('#dia_'+inputKey).val(inputValues);
      setTimeout(function(){ 
        if(inputValues != ""){          
          var filterValues = `${translations.titleCertificateOrStockNumber}: ${inputValues}`;
          jQuery("#search-by-certificate-input").val(inputValues);
          setSelectedFilter(filterValues,"removeSearchByCertificateFilter()", true, key);
        }
      }, 50);
    }else if(key == 'Price' || key == 'Carat' || key == 'Table' || key == 'Depth' || key == 'Ratio'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }else{            
      $('#'+inputKey+'_min_value').val(value[0]);
      $('#'+inputKey+'_max_value').val(value[1]);
    }    
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();

      if(filterTitle == 'colour'){
        filterTitle = 'fancy-color';
      }
      
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,value);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-diamondlist-result-grid-view-item a", function() {
  var diamond_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(diamond_id,diamond_page);
});
/*** Onclick Diamond Listing Grid Recent Diamond Detail Stored in Session End ***/

/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session Start ***/
$(document).on("click", ".tps-diamondlist-detail-view-btn", function() {
  var diamond_id = $(this).attr("data-id");  
  var diamond_page = $(this).attr("data-page");
  setRecentProductData(diamond_id,diamond_page);
});
/*** Onclick Diamond Listing Recent Diamond Detail Stored in Session End ***/

/*** Recently viewd Diamond Stored in Session Start ***/
function setRecentProductData(diamond_id,diamond_page){
  //store single recently viewed diamond 
  updateSessionFilters(session_variable+'-other-data','Single-Recent-Diamond', diamond_id);
  updateSessionFilters(session_variable+'-other-data','Recent-Diamond-Page-No', diamond_page);
  //end

  //store recently viewed diamonds 
  var products_ids = '';
  if(session_other_data['Recent-Diamonds'] != null && session_other_data['Recent-Diamonds'] != ''){
    var products_ids = session_other_data['Recent-Diamonds'];
    products_ids = products_ids.toString();
  }
 
  var recentDiamondsData = [];
  if (products_ids == "" || products_ids == null) {
    var recent_diamonds = [];
  } else {
    recent_diamonds = products_ids.split(",");
  }

  if (jQuery.inArray(diamond_id.toString(), recent_diamonds) == (-1)) {
    recent_diamonds.push(diamond_id);
  }else{
    
  } 
  
  updateSessionFilters(session_variable+'-other-data','Recent-Diamonds', recent_diamonds.toString());
  //end  
}
/*** Recently viewd Diamond Stored in Session End ***/

/*** Get Recent Diamonds Tab Active Start ***/
function getRecentDiamonds() {
  if(session_other_data['Recent-Diamonds'] != null && session_other_data['Recent-Diamonds'] != undefined){
    var recentDiamonds = session_other_data['Recent-Diamonds'].toString();
    var recentCount = session_other_data['Recent-Diamonds'].length;
    var ViewType = session_other_data['View-Type'][0];
    
    showLoader('recent');
    jQuery("#diamond_active_tab").val('recent');
    jQuery(".tps-diamond-result-data").hide();
    jQuery(".tps-recent-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-recent-diamonds-tab").addClass('active-tab');
    getCompareRecentDataCall(recentDiamonds,'recent');
  }else{
    alert(translations.titleRecentlyViewedDiamondsNotFound);
    return false;
  }  
}
/*** Get Recent Diamonds Tab Active End ***/

/*** Add Diamond For Compare ***/
function compareDiamonds(id) {
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  var diamond_name = jQuery('.diamond-checkbox-'+id).attr('data-diamond-name');
  
  var compareArray = [];
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
      var compareArray = session_other_data['Compare-Diamonds'];
    }
  }

  if(jQuery.inArray(id.toString(),compareArray)==(-1)){
     if(jQuery('.diamond-checkbox-'+id).is(':checked')){
        compareArray.push(id); 
        jQuery('.diamond-compare-'+id).addClass('active');

         //display toast message when diamond added for compare
        jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleAddedForCompare);           
         $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
        setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

        if(jQuery('.tps-grid-view').hasClass('active')){        
          jQuery('.diamond-checkbox-'+id).prop('checked', true);   
        }
     }
  }else{
      compareArray.splice(compareArray.indexOf(id.toString()), 1);
      jQuery('.diamond-compare-'+id).removeClass('active');

      //display toast message when diamond remove from compare
      jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleremovedFromCompare);
      $(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");
      setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);

      if(jQuery('.tps-grid-view').hasClass('active')){        
        jQuery('.diamond-checkbox-'+id).prop('checked', false);   
      }
  }
  
  updateSessionFilters(session_variable+'-other-data','Compare-Diamonds', compareArray.toString());
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 
}
/*** End ***/

/*** Get Compare Diamonds Start ***/
function getCompareDiamonds() {  
  jQuery('.tps-compare-diamond-data .tps-diamondlist-result-list-view-items-list').removeClass('tps-no-diamonds-found');
  jQuery('.tps-compare-diamond-data .tps-diamondlist-result-grid-view-items-list').removeClass('tps-no-diamonds-found');
  
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != undefined){
    var compareDiamonds = session_other_data['Compare-Diamonds'].toString();
    var compareCount = session_other_data['Compare-Diamonds'].length;
    var ViewType = session_other_data['View-Type'][0];

    if(session_other_data['Compare-Diamonds'].length == 1 && session_other_data['Compare-Diamonds'][0] == ''){
      alert(translations.titleCompareDiamondsNotFound);
      return false;
    }
    
    showLoader('compare');
    jQuery("#diamond_active_tab").val('compare');
    jQuery(".tps-diamond-result-data").hide();
    jQuery(".tps-compare-diamond-data").show();
    jQuery(".tps-listing-tabs").removeClass('active-tab');
    jQuery(".tps-compare-diamonds-tab").addClass('active-tab');
    
    getCompareRecentDataCall(compareDiamonds,'compare');    
  }else{
    alert(translations.titleCompareDiamondsNotFound);
    return false;
  }    
}
/*** Get Compare Diamonds End ***/

/*** Remove Diamonds From Compare Start ***/
function removeCompare(id) {  
  var active_tab = jQuery("#diamond_active_tab").val(); 
  var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
  if(session_other_data != '' && session_other_data != null){
    if(session_other_data['Compare-Diamonds'] != null && session_other_data['Compare-Diamonds'] != ''){
      var compareArray = session_other_data['Compare-Diamonds'];
    }
  }
  compareArray.splice(compareArray.indexOf(id.toString()), 1);
  
  var compareCount = compareArray.length;
  jQuery(".tps-compare-count").html("("+compareCount+")"); 
  
  updateSessionFilters(session_variable+'-other-data','Compare-Diamonds', compareArray.toString());    
  jQuery("[data-product-id='" + id + "']").prop('checked', false);

  if(compareCount == 0){    
     var diaListView = '<span class="tps-no-diamond-found">'+translations.titleDiamondNotFoundForCompare+'</span>';
     var diaGridView = '<span class="tps-no-diamond-found">'+translations.titleDiamondNotFoundForCompare+'</span>';

     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').addClass('tps-no-diamonds-found');
     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').addClass('tps-no-diamonds-found');

     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html(diaListView);
     jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(diaGridView);    
  }

  //display toast message when diamond remove from compare
  var diamond_name = jQuery('.diamond-checkbox-'+id).attr('data-diamond-name');
  jQuery('.tps-toast-msg-content').html(diamond_name+' '+translations.titleremovedFromCompare);
  jQuery(".tps-toast-msg-popup-wrapper").addClass("tps-popoup-show");

  jQuery('.diamond-compare-'+id).removeClass('active');
  jQuery("[data-compare-id='"+id+"']").remove();

  setTimeout(function() { $(".tps-toast-msg-popup-wrapper").removeClass('tps-popoup-show'); }, 2000);
}
/*** Remove Diamonds From Compare End ***/

/*** Close Compare Message Popup Start ***/
function closePopup() {
  $(".tps-toast-msg-popup-wrapper").removeClass("tps-popoup-show");
}
/*** Close Compare Message Popup End ***/

/*** Graphql API Call To Get Diamond For Compare & Recent Diamonds Start ***/
function getCompareRecentDataCall(diamond_data,flag) {   
  var diamond_type = jQuery('#diamond_type').val(); 
  if(diamond_type == 'white' || diamond_type == 'fancy'){
     diamondDetailApi = rapnetDiamondDetailApi;
  }else{
     diamondDetailApi = labDiamondDetailApi;
  } 
  
  var active_tab = flag;
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html('');
  jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html('');
  
  //query parameters for graphql call
  var postdata = JSON.stringify({
      query: `{
                  ${diamondDetailApi}(diamondId: "` + diamond_data +`")
                  {                    
                   diamond{
                    diamondId 
                    shape 
                    caratWeight  
                    color 
                    fancyColor
                    fancyColorIntensity
                    fancyColorOvertone
                    clarity 
                    cut 
                    symmetry 
                    polish 
                    deptPerc 
                    tablePerc 
                    length 
                    width 
                    depth 
                    ratio 
                    measurement 
                    girdle 
                    girdleMin 
                    girdleMax 
                    girdleCondition 
                    culet 
                    culetCondition  
                    flourIntensity  
                    certificateFile 
                    lab  
                    finalPriceAud  
                    certificateNumber 
                    stockNumber 
                    diamondImage  
                    diamondVideo  
                    diamondType 
                    currencyCode 
                    currencySymbol                       
                   }
                  }
                  }
                  `
    });
    abortAjax(xhr);  
    xhr = jQuery.ajax({ 
        url: api,
        contentType: "application/json",
        type: 'POST',
        data: postdata,
        success: function(response) {
            var allDiamondData = response.data[diamondDetailApi].diamond;            
            if(active_tab == 'recent'){
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').remove();
            }else{
              jQuery('.tps-'+active_tab+'-diamond-data .table-head-compare').html(translations.titleRemove);
            }
          
            var diaListView = '';
            var diaGridView = '';            
            
            $.each(allDiamondData, function(i, diamondData) { 
               diaListView += getDiamondListingViewLayout(diamondData,'',active_tab);
               diaGridView += getDiamondListingGridLayout(diamondData,'',active_tab);
            });                       

            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-items-list').html(diaListView);
            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-items-list').html(diaGridView);

            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-list-view-loader').hide();
            jQuery('.tps-'+active_tab+'-diamond-data .tps-diamondlist-result-grid-view-loader').hide();
        }
    });

}
/*** End ***/

/*** Get All Diamonds Tab Active ***/ 
function getAllDiamonds(){
  jQuery("#diamond_active_tab").val('all');
  jQuery(".tps-diamond-result-data").hide();
  jQuery(".tps-all-diamond-data").show();
  jQuery(".tps-listing-tabs").removeClass('active-tab');
  jQuery(".tps-all-diamonds-tab").addClass('active-tab');
}
/*** End ***/

/*** search by certificate number or stock number start ***/
function searchByDiamondCertificateOrStockNumber(){
  var searchVal = jQuery("#search-by-certificate-input").val().trim();
  if(searchVal == ""){
    searchVal = jQuery("#dia_search-certificate").val();
  }
  var isSelected = false;
  var filterKey = 'search-certificate';
  var filterValues = `${translations.titleCertificateOrStockNumber}: ${searchVal}`;
  if(searchVal == ""){
    return false;
  }

  if(searchVal){
    resetFilters(false);
    jQuery("#search-by-certificate-input").val(searchVal);
    jQuery('#page_no').val(1);
    jQuery('#pagination').val('');
    jQuery('.diamond-grid-row').removeClass('tps-recent-viewed-diamond');
    jQuery('.diamond-list-row').removeClass('tps-recent-viewed-diamond');
    var diamond_active_tab = jQuery('#diamond_active_tab').val();  
    showLoader(diamond_active_tab); 
    jQuery(".tps-dia-count").html("(<span class='tps-dia-count-loader'></span>)"); //display diamond count loader before diamonds load

    var diamond_type = jQuery('#diamond_meta_type').val(); 
    var diamondTypeGraphql = "";
    if(diamond_type == 'lab-color'){
       diamondTypeGraphql = 'fancy';
    }
    
    //session search by certificate filter selected
    isSelected = true;
    setSelectedFilter(filterValues,"removeSearchByCertificateFilter()", isSelected, filterKey);
    
    //query parameters for graphql call
    var postdata = JSON.stringify({
      query: `{        
        ${diamondSearchByReportApi}(inputId: "` + searchVal +`", diamondType: "` + diamondTypeGraphql +`")
        {                    
         diamond{
          diamondId 
          shape 
          caratWeight  
          color 
          fancyColor
          fancyColorIntensity
          fancyColorOvertone
          clarity 
          cut 
          symmetry 
          polish 
          deptPerc 
          tablePerc 
          length 
          width 
          depth 
          ratio 
          measurement 
          girdle 
          girdleMin 
          girdleMax 
          girdleCondition 
          culet 
          culetCondition  
          flourIntensity  
          certificateFile 
          lab  
          finalPriceAud  
          certificateNumber 
          stockNumber 
          diamondImage  
          diamondVideo  
          diamondType 
          currencyCode 
          currencySymbol                       
         }
        }
      }`
    });
    abortAjax(xhr);  
    xhr = jQuery.ajax({ 
      url: api,
      contentType: "application/json",
      type: 'POST',
      data: postdata,
      success: function(response) {
        var dia_data = response.data[diamondSearchByReportApi].diamond;    
        var bulk_page_data = getBulkPageDataValuesFromSession();
        getDiamondListView(dia_data,dia_data.length,dia_data.length,bulk_page_data);          
      
        //set value in session
        var session_variable = jQuery("#session_variable").val();
        updateSessionFilters(session_variable+'-filters', filterKey, searchVal);
      }
    });
  }  
}
/*** search by certificate number or stock number end ***/
